<template>
  <div class="ccsqdTpl">
   

    <el-row>
      <el-col :span="6" v-for="(item, index) in list" :key="index" :offset="index > 0 ? 2 : 0">
        <el-card :body-style="{ padding: '0px' ,width:'150px',height:'150px'}" >
          <img :src="item.logo" class="image" @click.prevent="slClick(item)" />
          <!-- <div style="padding: 14px;">
            <span class="title">{{item.title}}</span>
        
          </div> -->
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "TmcLogin",
  data() {
    return {
      list: [
        // {
        //   title: "空港嘉华",
        //   logo: require("@/assets/image/oa/kgjh_logo.png"),
        //   key: "kgjh",
        //   val: 1,
        // },
        // {
        //   title: "携程商旅",
        //   logo: require("@/assets/image/oa/xcsl_logo.png"),
        //   key: "xcsl",
        //   val: 2,
        // },
      ],
      urlQueryObj: {},
    };
  },
  mounted() {
    // 获取完整的URL
    this.urlQueryObj = this.$common.localget('tmcLoginInfo') || {};

    // 是否特变环境
    let isItbeaChrome = navigator && /itbea/.test(navigator.userAgent);
    if(this.urlQueryObj.version == 2 && isItbeaChrome){
      if(this.urlQueryObj.ticket){
        // 直接登录版本2接口
        this.slClick();
      }else{
        this.initItbeaChrome();
      }
          
    }else{
      this.slClick()
    }
    
    
  },
  methods: {
      // 初始化特变环境
      initItbeaChrome(){
        let self = this;
        var ItbeaMap = {
					url: 'https://itbea-api-dev.tbea.com:30030/itbea-sdk.js',
					id: 'ItbeaJsApi',
					callback() {
            self.initGetCode();
						
					}
				}
        try {
          // 如果页面已经加载过 特变js，则直接授权登录
          if(itbea && itbea.getCodeTicket){
            self.initGetCode();
          }else{
            // 动态加载
            this.$common.getScriptDom(ItbeaMap.url, ItbeaMap.id, ItbeaMap.callback);
          }
        } catch (error) {
          
        }
       
      },
      // 初始化获取code
      initGetCode(){
        itbea.getCodeTicket({
              success: (res)=> {
              //   返回值：
              // authCodeType: code  或者  ticket
              // code: xxxxxx
                this.urlQueryObj.ticket = res[res.authCodeType || 'code'];

                this.slClick();
              },
              fail: (err)=> {
                
                this.$common.tips(err);
              },
        });
      },
    // 点击
    /**
     * 
     *     接口：
          1.0.0/tbea/sso
          @ApiModelProperty(value = "1-空港 2-携程") private String channel;
          @ApiModelProperty(value = "1-PC 2-H5")private String type;
          @ApiModelProperty(value = "特变参数")private String ticket;
     * 
     * **/
    slClick() {
        if(!this.urlQueryObj.ticket){

          this.$message.error('非法的单点方式！')
          return 
        }
      let queryObj = {
        channel: this.urlQueryObj.channel, //1-空港 2-携程
        type: 1, // 1-PC 2-H5
        ticket: this.urlQueryObj.ticket, // 特变参数
      };
      let queryUrl = "user.tbeaSso";
      if(this.urlQueryObj.version == 2){
        queryUrl = "user.tbeaSso2";
      }
      
      this.$conn.getConn(queryUrl,{jsfile:false})(queryObj,(res)=>{
        let data = res.data || "";
        
          if (data) {
            // 空港嘉华
            if(this.urlQueryObj.channel == 1){
              window.location.replace(data);
              return 
            }
            
            if(data.indexOf('form')>-1){
                this.dongLoadingFormHtmlText(data)
            }else{
                this.dongLoadingHtmlText(data);
            }
            
          } else {
            let tips = '未获取有效的单点链接';
            this.$message.error(tips)
      
          }
				},(err)=>{
					this.$message.error(err.tips)
				})
      
  
    },


    //  动态加载 html文本 , 并执行脚本
    dongLoadingHtmlText(htmlStr){
      const parser = new DOMParser();
        const doc = parser.parseFromString(htmlStr, 'text/html');

        // 插入到当前页面
        document.body.innerHTML = doc.body.innerHTML;

        // 手动执行 script
        const scripts = document.body.querySelectorAll('script');
        scripts.forEach(script => {
          const newScript = document.createElement('script');
          newScript.text = script.text;
          document.body.appendChild(newScript);
        });
    },

    // 动态加载form 表单，并提交表单  
    dongLoadingFormHtmlText(htmlStr){
      var el = document.getElementById('tmc_login_url');
						if (el) {
							el.parentNode.removeChild(el);
							el = null;
						}
						var div = document.createElement('div');
						div.setAttribute('id', 'tmc_login_url');
						document.body.appendChild(div);

            div.innerHTML = htmlStr;
						var forms = document.querySelectorAll("#tmc_login_url  form");
						forms[0].submit();
    }

  },
};
</script>

<style scoped>
.ccsqdTpl {
  width: 750px;
  margin: 0 auto;
  font-size: 14px;
  padding: 20px;
}
.bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    height: 100%;
    /* display: block; */
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }
  
  .clearfix:after {
      clear: both
  }
  .title{
    font-weight: 600;
  }
</style>
